import { useState } from 'react';
import type { ToolAccessRpcError } from '../../__generated__/chirp/com/hubspot/tool/access/rpc/ToolAccessService';
import { User } from '../types/User';

type State = {
  message: string;
  error: null | ToolAccessRpcError;
  approver?: User;
};

const initialState: State = {
  message: '',
  error: null,
} as const;

export const useToolAccessRequestForm = () => {
  const [formState, setFormState] = useState(initialState);

  const setApprover = (approver: User) =>
    setFormState((prevState) => ({
      ...prevState,
      approver,
    }));

  const setMessage = (message: string) =>
    setFormState((prevState) => ({
      ...prevState,
      message,
    }));

  const setError = (error: State['error']) =>
    setFormState((prevState) => ({
      ...prevState,
      error,
    }));

  const resetForm = () => {
    setFormState(initialState);
  };

  return {
    formState,
    setApprover,
    setMessage,
    setError,
    resetForm,
  };
};
